import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { DashboardMetricCard } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-metric-card',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './dashboard-metric-card.component.html',
})
export class DashboardMetricCardComponent {

  @Input({ required: true })
  public metric!: DashboardMetricCard;

  public get iconColorClass(): string {
    return this.metric.variant === 'success' ? 'text-lSuccess' : 'text-lDanger';
  }

}
